import { TypographyVariantsOptions } from '@mui/material';

const typography: TypographyVariantsOptions = {
  fontFamily: "'Monument Grotesk', sans-serif",
  h1: {
    fontSize: '124px',
    fontWeight: 500,
    lineHeight: '90%',
    letterSpacing: '-4.96px',
    '@media(max-width: 768px)': {
      fontSize: '60px',
      letterSpacing: '-2.56px',
    },
  },
  h2: {
    fontSize: '104px',
    fontWeight: 500,
    lineHeight: '98%',
    letterSpacing: '-4.16px',
    '@media(max-width: 768px)': {
      fontSize: '48px',
      letterSpacing: '-1.92px',
    },
  },
  h3: {
    fontSize: '64px',
    fontWeight: 400,
    lineHeight: '98%',
    letterSpacing: '-2.56px',
    '@media(max-width: 768px)': {
      fontSize: '48px',
      letterSpacing: '-1.92px',
    },
  },
  h4: {
    fontSize: '48px',
    fontWeight: 400,
    lineHeight: '110%',
    letterSpacing: '-1.92px',
  },
  h5: {
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: '-1.28px',
  },
  subtitle1: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '130%',
    letterSpacing: '-0.96px',
  },
  subtitle2: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '130%',
    letterSpacing: '-1px',
  },
  subtitle3: {
    fontFamily: "'Monument Grotesk', sans-serif",
    fontSize: '18px',
    lineHeight: 'normal',
  },
  body1: {
    fontFamily: "'Monument Grotesk', sans-serif",
    fontSize: '16px',
    lineHeight: 'normal',
  },
  body2: {
    fontFamily: "'Monument Grotesk', sans-serif",
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '-0.7px',
  },
  body3: {
    fontFamily: "'Monument Grotesk', sans-serif",
    fontSize: '12px',
    lineHeight: '140%',
  },
  button: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 600,
    textTransform: 'none',
    textBoxTrim: 'trim-both',
    textBoxEdge: 'cap alphabetic',
  },
};

export default typography;
